var _circle, _circle2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBegginerLevel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#F8ECD5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4487_28444",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4487_28444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-5.57291 40.4961C-5.57291 40.4961 39.3258 39.9754 39.3258 37.5596C39.3258 35.1438 37.7986 22.0196 16.3165 15.6571C16.3165 15.6571 19.9817 8.3154 18.5563 7.58117C17.131 6.84715 16.0112 12.231 16.0112 12.231C16.0112 12.231 15.8074 3.54343 14.2803 4.03277C12.7531 4.52211 13.7712 13.4546 13.7712 13.4546C13.7712 13.4546 10.6151 6.60248 9.49507 7.7035C8.37519 8.80474 13.4658 15.7794 13.4658 15.7794C13.4658 15.7794 0.637619 20.5516 -4.86037 36.2135C-4.86037 36.2135 -6.79458 38.7832 -5.57291 40.4961Z",
    fill: "#9568A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4.46856 40.7617C-4.46856 40.7617 40.4302 40.241 40.4302 37.825C40.4302 35.4092 38.9031 22.2853 17.4209 15.9225C17.4209 15.9225 21.0861 8.58102 19.6608 7.84656C18.2354 7.11255 17.1155 12.4964 17.1155 12.4964C17.1155 12.4964 16.9119 3.80882 15.3847 4.29839C13.8575 4.78773 14.8755 13.72 14.8755 13.72C14.8755 13.72 11.7195 6.86788 10.5996 7.96912C9.47972 9.07014 14.5702 16.0448 14.5702 16.0448C14.5702 16.0448 1.74196 20.817 -3.75584 36.4789C-3.75584 36.4789 -5.69024 39.0486 -4.46856 40.7617Z",
    stroke: "#1C2541",
    strokeWidth: 0.551214,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3361 19.2345C16.3361 19.4589 16.1848 19.6406 15.9984 19.6406C15.8117 19.6406 15.6606 19.4589 15.6606 19.2345C15.6606 19.0104 15.8117 18.8287 15.9984 18.8287C16.1848 18.8287 16.3361 19.0104 16.3361 19.2345Z",
    fill: "#1C2541"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7177 18.8285C17.7177 19.0529 17.5664 19.2344 17.3799 19.2344C17.1933 19.2344 17.0422 19.0529 17.0422 18.8285C17.0422 18.6044 17.1933 18.4226 17.3799 18.4226C17.5664 18.4226 17.7177 18.6044 17.7177 18.8285Z",
    fill: "#1C2541"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2437 20.9667C14.2437 20.9667 16.3658 24.1454 20.519 20.5124",
    stroke: "#1C2541",
    strokeWidth: 0.551214,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBegginerLevel);
export default __webpack_public_path__ + "static/media/begginer-level.de2bc4bd9f41e8713ae7380b0b3b8b47.svg";
export { ForwardRef as ReactComponent };